<script setup lang="ts">
import { enUS } from 'date-fns/locale'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

import { faCalendar } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'DisciplineOrderExpires',
})

withDefaults(defineProps<{
  timezone: string
  minDate?: Date
  disabled?: boolean
}>(), {
  minDate: undefined,
  disabled: false,
})

const model = defineModel<Date | null>({ default: null })
</script>

<template>
  <div class="discipline-order-expires">
    <AppText
      name="body2"
      color="slate-900"
    >
      Order expires at:
    </AppText>
    <Datepicker
      v-model="model"
      :min-date="minDate"
      :time-config="{ timePickerInline: true, enableTimePicker: true }"
      :locale="enUS"
      :week-start="1"
      :formats="{ input: 'MMM dd, yyyy HH:mm' }"
      :disabled="disabled"
      clearable
      placeholder="Select expiration date"
      teleport-center
    >
      <template #input-icon>
        <AppIcon :icon="faCalendar" />
      </template>
    </Datepicker>
    <AppText
      name="body2"
      color="slate-500"
    >
      Date & Time shown in customer’s timezone ({{ timezone || '-' }})
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineOrderExpires.scss" />
